/**
 * 講師選択のサジェスト機能
 * input[list]で講師名を入力すると、対応する講師IDをhidden inputにセットする
 */
document.addEventListener('DOMContentLoaded', function() {
    // 講師名とIDのマッピングを取得
    const datalist = document.getElementById('lecturer_users_list');
    if (!datalist) {
        return;
    }

    const lecturerUsers = {};
    const options = datalist.querySelectorAll('option');
    options.forEach(function(option) {
        const name = option.value;
        const id = option.dataset.id;
        if (name && id) {
            lecturerUsers[name] = id;
        }
    });

    // 講師入力フィールドの変更を監視
    document.addEventListener('input', function(e) {
        if (!e.target.classList.contains('lecturer-user-input')) {
            return;
        }

        const inputValue = e.target.value;
        const parent = e.target.parentElement;
        const hiddenInput = parent.querySelector('.lecturer-user-id-hidden');

        if (hiddenInput) {
            if (lecturerUsers[inputValue]) {
                hiddenInput.value = lecturerUsers[inputValue];
            } else {
                hiddenInput.value = '';
            }
        }
    });
});
